import { Iconference, Iparticipant } from '../types/twilio'
import { HTTP } from '../lib/axios'

export interface ConferenceOptions {
  event: 'warmEndpoint' | 'endCall' | 'leaveCall' | 'addToCall' | 'warmTransfer' | 'coldTransfer' | 'mute' | 'hold' | 'parkLeaveCall'
  accountId: string
  conference: Iconference
  conferenceSID?: string
  conferenceName?: string
  participants?: Array<string>
  participantSID?: string
  To?: string
  From?: string
  mute?: boolean
  hold?: boolean
  targetParticipantSID?: string
}

export const getTwilioToken = async (auth0Token: string, accountId: string, australisId: string) => {
  const result = await HTTP.post(`/voip/account/${accountId}/user/${australisId}/voiceToken`,
    {},
    {
      headers: {
        Authorization: `Bearer ${auth0Token}`
      }
    })
  console.log(result)
  return result.data
}

export const conferenceControl = async (auth0Token: string, accountId: string, australisId: string, conferenceId: string, options: ConferenceOptions) => {
  const result = await HTTP.post(
    `/voip/account/${accountId}/user/${australisId}/conference/${conferenceId}/controller`,
    options,
    {
      headers: {
        Authorization: `Bearer ${auth0Token}`
      }
    }
  )
  return result.data
}

export const warmConferenceControl = async (auth0Token: string, accountId: string, australisId: string, conferenceId: string) => {
  const result = await HTTP.post(
    `/voip/account/${accountId}/user/${australisId}/conference/${conferenceId}/controller`,
    {
      event: 'warmEndpoint',
      accountId
    },
    {
      headers: {
        Authorization: `Bearer ${auth0Token}`
      }
    }
  )
  return result.data
}

export const getDeviceTypeFromLabel = (label: string) => {
  if (label.length < 14) {
    return null
  }
  if (label.includes('sip:')) {
    return 'SIP'
  }
  const type = label.split('_')[1]
  if (type && typeof type === 'string') {
    switch (type.toLowerCase()) {
      case 'web':
        return 'WEB'
      case 'android':
      case 'ios':
        return 'MBL'
      default:
        return null
    }
  }
  return null
}
